/**
 * Wrapper function สำหรับตรวจสอบค่าแลปกับค่าปกติจาก medium.json
 * ใช้แทน hard-code ในไฟล์ formula ต่างๆ
 */

import { getNormalRange, compareWithNormalRange } from '../utils/normalRangeUtils';
import NoValueCheck from './NoValueCheck';

/**
 * ตรวจสอบค่าแลปด้วย medium.json
 * @param {string|number} value - ค่าที่ได้จากการตรวจ
 * @param {string} testName - ชื่อการตรวจตามใน medium.json เช่น "Hemoglobin", "WBC"
 * @param {string|number} gender - เพศ "male", "female", "1", "0", "M", "F"
 * @param {number} age - อายุ (ปี)
 * @param {string} displayName - ชื่อที่ใช้แสดงผล (ถ้าไม่ระบุจะใช้ testName)
 * @returns {Promise<object>} - {title, color, caption, suggest}
 */
export const checkWithMediumJson = async (value, testName, gender, age, displayName = '') => {
  // เช็คว่ามีค่าหรือไม่
  const noValueResult = NoValueCheck(value);
  if (noValueResult) {
    return noValueResult;
  }

  // แปลง gender
  let sex = gender;
  if (gender === 'male' || gender === '1') sex = 'M';
  if (gender === 'female' || gender === '0') sex = 'F';

  // ถ้าไม่มี displayName ให้ใช้ testName
  const finalDisplayName = displayName || testName;

  try {
    // ดึงค่าปกติจาก medium.json
    const normalRangeData = await getNormalRange(testName, sex, age);

    if (!normalRangeData) {
      // ไม่พบค่าปกติ
      return {
        title: 'ไม่พบข้อมูล',
        color: 'gray',
        caption: 'ไม่พบค่าอ้างอิงสำหรับการตรวจนี้',
        suggest: ''
      };
    }

    // เปรียบเทียบค่า
    return compareWithNormalRange(value, normalRangeData.normal_range, finalDisplayName);

  } catch (error) {
    return {
      title: 'ไม่พบข้อมูล',
      color: 'gray',
      caption: 'เกิดข้อผิดพลาดในการประมวลผล',
      suggest: ''
    };
  }
};

/**
 * Version แบบ synchronous สำหรับใช้ใน components ที่ต้องการ sync
 * (จะใช้ cache หรือ fallback ถ้าไม่มีค่า)
 */
export const checkWithMediumJsonSync = (value, normalRange, displayName = '') => {
  const noValueResult = NoValueCheck(value);
  if (noValueResult) {
    return noValueResult;
  }

  if (!normalRange) {
    return {
      title: 'ไม่พบข้อมูล',
      color: 'gray',
      caption: 'ไม่พบค่าอ้างอิง',
      suggest: ''
    };
  }

  return compareWithNormalRange(value, normalRange, displayName);
};

export default checkWithMediumJson;
